import React, { useEffect, useState } from 'react';
import NavbarOne from './navdash';
import PerformanceChart from "./chart";
import RecentActivities from "./recentact";
import Insights from "./insights";
import TableWithPagination from './table';
import Table from './table2';



const Dashboard = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1328);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1324);
      
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  


  const styles = {
    container: {
      padding: '10px 2px',
      paddingLeft: isMobile ? '8%' : isTablet ? '30%' : '15%',
      marginTop: '100px',
      paddingRight: isMobile ? '8%' : '1%',
      overflow: 'hidden',
    },
   
    statsContainer: {
      display: 'flex',
      justifyContent: isMobile ? 'center' : isTablet ? 'space-evenly' : 'space-between',
      flexWrap: 'wrap',
      margin: '20px 0',
    },
    statCard: {
      backgroundColor: '#f0f0f0',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      flex: isMobile ? '1 1 calc(50% - 15px)' : isTablet ? '1 1 calc(33% - 15px)' : '0 1 calc(28% - 15px)',
      height: '100px',
      margin: '10px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    greetingSection: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#e8f5e9',
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '30px',
      flexDirection: isMobile ? 'column' : 'row',
    },
    greetingText: {
      flex: 1,
      fontSize: '24px',
      fontWeight: 'bold',
      margin: isMobile ? '0 0 20px 0' : '0 20px 0 0',
      textAlign: 'left',
    },
    image: {
      width: '80px',
      height: '80px',
      borderRadius: '8px',
      marginLeft: '20px',
    },
    actionButton: {
      width: '200px',
      height: '50px',
      padding: '10px',
      margin: '5px',
      border: 'none',
      borderRadius: '5px',
      // backgroundColor: '#2a7f62',
      backgroundColor: '#2a7f62',
      color: 'white',
      cursor: 'pointer',
      transition: 'background-color 0.3s',
      marginTop: '5%',
    },
    icon: {
      fontSize: '25px',
      display: 'inline-block',
      margin: '0 auto 5px auto',
    },
    number: {
      fontSize: '24px',
      fontWeight: 'bold',
      display: 'inline-block',
      marginTop: '-5px',
      marginLeft: '25px',
    },
    chartContainer: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : isTablet ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: '10px',
      // gap: isMobile || isTablet ? '20px' : '0',
      gap: (isMobile && window.innerWidth >= 473 && window.innerWidth <621) ? '120px':
      (isMobile && window.innerWidth >= 621 && window.innerWidth <= 767) ? '220px'
       :isTablet ? '20px' : '0',
    },
    chart: {
      width: isMobile ? '100%' : isTablet ? '45%' : 'calc(33% - 20px)', // Adjust chart width
      margin: '0 10px',
      height: '400px',
      marginBottom: isMobile || isTablet ? '20px' : '0', 
      
    },
   
    pieChart: {
      height: '100px', // Match height with the bar chart
    },
    reportContainer: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : isTablet ? 'column' : 'row',
      gap: '20px',
    },
    reportLeftContainer: {
      flex: 1,
    },
    reportRightContainer: {
      flex: 1,
      backgroundColor: '#fff', 
      padding: '20px',  
      borderRadius: '8px',  
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', 
      marginTop: '5%',
      height: '600px', 
    },
    // graphContainer: {
    //   display: 'flex',
    //   justifyContent: isMobile ? 'space-between' : isTablet ? 'center' : 'space-between',
    //   flexDirection: isMobile ? 'column' : isTablet ? 'column' : 'row',
    //   marginTop: '1px',
    //   gap: isMobile ? '40px' : isTablet ? '40px' : '0',
    // },
    graphContainer: {
      display: 'flex',
      justifyContent: isMobile ? 'space-between' : isTablet ? 'center' : 'space-between', // Center the graphs in tablet view
      flexDirection: isMobile ? 'column' : isTablet ? 'row' : 'row', // Stack vertically on mobile, side by side on tablet and desktop
      marginTop: '1px',
      gap: isMobile ? '40px' : isTablet ? '20px' : '0',
      alignItems: isTablet ? 'center' : 'flex-start', // Ensure the graphs are centered horizontally in tablet view
    },
    
    totalWorksGraphContainer: {
        marginTop: isMobile ? '0' : '40px', 
        paddingBottom: isMobile ? '30px' : '20px', 
        height: isMobile ? 'auto' : '350px', 
    },
    doctorsListContainer: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : isTablet ? 'column' : 'row',
      justifyContent: 'space-between',
      margin: '20px 0',
    },
    doctorCard: {
      display: 'flex',
      alignItems: 'center', // Align items vertically
      backgroundColor: '#f0f0f0',
      borderRadius: '8px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      padding: '10px',
      margin: '10px', // Adjust margin for spacing
      textAlign: 'left',
      flex: '1 1 calc(45% - 20px)', // Two cards per row
      minWidth: '280px', // Ensure it fits within mobile screens
      position: 'relative',
    },
    doctorImage: {
      width: '80px',
      height: '80px',
      borderRadius: '50%',
      marginRight: '20px', // Space between image and text
    },
    doctorInfo: {
      flex: 1, // Allow this section to take available space
      textAlign: 'center',
    },
    doctorName: {
      fontSize: '18px',
      fontWeight: 'bold',
      margin: '5px 0',
    },
    doctorDept: {
      fontSize: '14px',
      color: '#555',
    },
    dotsIcon: {
      cursor: 'pointer',
      fontSize: '20px',
      position: 'absolute',
      right: '10px',
      top: '10px',
      color: '#555',
    },
    doctorsOnLeaveContainer: {
      margin: '1px 0',
      padding: '10px',  // Add padding around the container
      backgroundColor: '#eae8e8',  // Background color for the container
      borderRadius: '8px',  // Rounded corners for the container
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      maxHeight: isMobile ? '10%' : '430px',
      marginLeft: isMobile ? '0' : '1%',  
      marginRight: isMobile ? '0' : '1%',
      
      marginTop: '2%',
    },
    doctorsOnLeaveTitle: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '15px', 
      color: '#333',
      textAlign: 'center', 
    },
    tableContainer: {
      overflowX: 'auto',  // Allow horizontal scrolling if needed
      marginBottom: '20px', // Space below the table
    },
    doctorsOnLeaveTable: {
      width: '100%',
      borderCollapse: 'collapse',
      borderRadius: '8px',  
      overflow: 'hidden',  
    },
    tableHeader: {
      // backgroundColor: '#2a7f62',00a9a4
      backgroundColor: '#1c6b4b',
      fontWeight: 'bold',
      textAlign: 'left',
      padding: '12px',
      color: 'white',
    },
    tableCell: {
      padding: '12px',
      borderBottom: '1px solid #ddd',
    },
    tableRow: {
      transition: 'background-color 0.3s ease',
    },
    tableRowHover: {
      backgroundColor: '#f1f1f1', // Light hover effect
    },
    arrowsContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '10px',
    },
    arrowButton: {
      fontSize: '24px',
      // color: '#2a7f62',
      color: '#1c6b4b',
      cursor: 'pointer',
      margin: '0 10px',
    },
    tableContainer1: {
      margin: '20px 0',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#eae8e8',
      width: '100%',
      marginLeft: '1%',
      marginRight: isTablet ? '70px' : '0',
  },
  table1: {
      width: '100%',
      borderCollapse: 'collapse',
      overflowX: 'auto',
      backgroundColor: '#eae8e8',
  },
  th: {
      // backgroundColor: '#2a7f62',
      backgroundColor: '#1c6b4b',
      color: 'white',
      padding: '10px',
      textAlign: 'center',
  },
  td: {
      padding: '10px',
      borderBottom: '1px solid #ddd',
      textAlign: 'center',
  },
  tableHeading: {
      fontSize: '24px',
      margin: '20px 0',
      textAlign: 'center',
  },
  scrollContainer: {
      overflowX: 'auto',
  },

  };

  return (
    <div>
      <NavbarOne />
      <div style={styles.container}>
        <div style={styles.content}>
          <div className="flex justify-between items-center bg-white p-6 rounded shadow-md">
        <div>
          <h1 className="text-3xl font-bold">Welcome, Admin</h1>
          <p className="text-gray-600 mt-2">
            All systems are running smoothly! You have{" "}
            <span className="font-bold text-green-600">5 new job applications</span> and{" "}
            <span className="font-bold text-blue-600">2 new company registrations</span>.
          </p>
        </div>
        <div className="text-center">
          <p className="text-xl font-semibold">31°C</p>
          <p className="text-gray-600">Chicago, Illinois</p>
        </div>
      </div>
  <div className="p-6 flex-1 bg-gray-100">
      {/* Metrics and Insights */}
      <Insights />

      {/* Performance Charts */}
      <PerformanceChart />
      
            <Table />
        

      {/* Recent Activities */}
      <RecentActivities />
    </div>
    <div>
            <TableWithPagination />
        </div>
        

  <div className="p-6 flex-1 bg-gray-100">
     
      <div className="bg-white p-6 rounded shadow-md mt-6">
        <h2 className="text-2xl font-bold">Team Overview</h2>
        <div className="grid grid-cols-3 gap-6 mt-4">
          <div className="text-center">
            <img
              className="h-16 w-16 rounded-full mx-auto"
              src="user5.jpeg"
              alt="Team Member"
            />
            <p className="mt-2 font-bold">Jane Smith</p>
            <p className="text-gray-500 text-sm">Recruitment Specialist</p>
          </div>
          <div className="text-center">
            <img
              className="h-16 w-16 rounded-full mx-auto"
              src="user8.jpeg"
              alt="Team Member"
            />
            <p className="mt-2 font-bold">John Doe</p>
            <p className="text-gray-500 text-sm">HR Manager</p>
          </div>
          <div className="text-center">
            <img
              className="h-16 w-16 rounded-full mx-auto"
              src="user6.jpeg"
              alt="Team Member"
            />
            <p className="mt-2 font-bold">Sarah Lee</p>
            <p className="text-gray-500 text-sm">Marketing Lead</p>
          </div>
        </div>
      </div>
    </div>
    <div className="p-6 flex-1 bg-gray-100">
     
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
  {/* Job Market Insights */}
  <div className="bg-white p-6 rounded shadow-md">
    <h2 className="text-2xl font-bold">Job Market Insights</h2>
    <p className="text-gray-600 mt-2">
      Key metrics showcasing the current trends and statistics in the job market
      within the selected date range.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
      <div className="text-center">
        <p className="text-3xl font-bold text-blue-600">8.2k</p>
        <p className="text-gray-500">Active Jobs</p>
      </div>
      <div className="text-center">
        <p className="text-3xl font-bold text-green-600">15.7k</p>
        <p className="text-gray-500"> Submitted Applications</p>
      </div>
      <div className="text-center">
        <p className="text-3xl font-bold text-purple-600">67.45%</p>
        <p className="text-gray-500">Employment Rate</p>
      </div>
    </div>
  </div>

  {/* Job Market Report */}
  <div className="bg-white p-6 rounded shadow-md">
    <h2 className="text-2xl font-bold flex justify-between items-center">
      Job Market Report{" "}
      <span className="text-blue-500 cursor-pointer hover:underline">View All</span>
    </h2>
    <p className="text-gray-600 mt-2">
      An overview of job market activities within the selected date range, including job
      listings, applications, and hiring trends.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
      <div className="text-center">
        <p className="text-3xl font-bold text-orange-600">12.3k</p>
        <p className="text-gray-500">Job Applications</p>
      </div>
      <div className="text-center">
        <p className="text-3xl font-bold text-red-600">4.8k</p>
        <p className="text-gray-500">Hires</p>
      </div>
    </div>
  </div>
</div>
    </div>

         
          
        </div>

      




      </div>
    </div>
  );
};

export default Dashboard;
